module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.length > 1),
      expression: "length > 1"
    }],
    class: _vm.classes
  }, [(_vm.value > 1) ? _c('a', {
    staticClass: "dn-pagination__item dn-pagination__prev",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onClickPrev($event)
      }
    }
  }, [_c('dn-icon', {
    class: {
      'is-disabled': _vm.disabled
    },
    attrs: {
      "icon": "arrow-left"
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.items), function(n) {
    return (!isNaN(n)) ? _c('a', {
      class: {
        'dn-pagination__item dn-pagination__number': true, 'dn-pagination__number--active': n === _vm.value
      },
      attrs: {
        "href": "javascript:void(0);"
      },
      domProps: {
        "textContent": _vm._s(n)
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onClickNumber(n)
        }
      }
    }) : _c('span', {
      staticClass: "dn-pagination__item dn-pagination__more",
      domProps: {
        "textContent": _vm._s(n)
      }
    })
  }), _vm._v(" "), (_vm.value !== _vm.length) ? _c('a', {
    staticClass: "dn-pagination__item dn-pagination__next",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onClickNext($event)
      }
    }
  }, [_c('dn-icon', {
    class: {
      'is-disabled': _vm.disabled
    },
    attrs: {
      "icon": "arrow-right"
    }
  })], 1) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e4079ec","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/ui/components/paginations/Pagination.vue
// module id = 311
// module chunks = 1